<template>
    <Container class="px-[18px]">
        <hr :style="paddingStyle" class="border-t-2 border-[#D4DBE8]" />
    </Container>
</template>

<script>
import Container from '../../../Layouts/Container.vue'

export default {
    components: {
        Container,
    },
    props: {
        paddingTop: {
            type: Number,
            default: 10,
        },
        paddingBottom: {
            type: Number,
            default: 10,
        },
        mobilePaddingTop: {
            type: Number,
            default: 10,
        },
        mobilePaddingBottom: {
            type: Number,
            default: 10,
        },
    },
    data() {
        return {
            isMobile: false,
        };
    },
    computed: {
        paddingStyle() {
            return {
                marginTop: this.isMobile ? `${this.mobilePaddingTop}px` : `${this.paddingTop}px`,
                marginBottom: this.isMobile ? `${this.mobilePaddingBottom}px` : `${this.paddingBottom}px`,
            };
        },
    },
    mounted() {
        this.checkIfMobile();
        window.addEventListener('resize', this.checkIfMobile);
    },
    beforeDestroy() {
        window.removeEventListener('resize', this.checkIfMobile);
    },
    methods: {
        checkIfMobile() {
            this.isMobile = window.matchMedia('(max-width: 768px)').matches;
        },
    },
};
</script>
